import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { appendScript } from 'utils/bom-dom-manipulation/append-script';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { setSeonSessionData } from 'store/actions/app-data';

export const useSeonIntegration = (): void => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (SpringConfigs.SEON_INTEGRATION && !window.seon) {
      appendScript(
        'https://cdn.deviceinf.com/js/v5/agent.js',
        'seonScript',
        () => {
          if (window.seon) {
            window.seon?.getBase64Session((data: any) => {
              if (data) {
                dispatch(setSeonSessionData(data));
              } else {
                console.error('Failed to retrieve session data');
              }
            });
          }
        }
      );
    }
  }, []);
};
